export function initNav(): void {
  const burger = document.getElementById('burger');
  const overlay = document.getElementById('nav-overlay');

  function openMenu(): void {
    burger?.classList.add('is-open');
    overlay?.classList.add('is-open');
    burger?.setAttribute('aria-expanded', 'true');
    overlay?.setAttribute('aria-hidden', 'false');
  }

  function closeMenu(): void {
    burger?.classList.remove('is-open');
    overlay?.classList.remove('is-open');
    burger?.setAttribute('aria-expanded', 'false');
    overlay?.setAttribute('aria-hidden', 'true');
  }

  burger?.addEventListener('click', () => {
    burger.classList.contains('is-open') ? closeMenu() : openMenu();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay?.classList.contains('is-open')) closeMenu();
  });

  // Close when a nav link is clicked — sauf en mode édition CMS, où cliquer sert à
  // positionner le curseur dans le lien (contenteditable) pour le modifier, pas à naviguer.
  overlay?.querySelectorAll('.nav-overlay__link').forEach((link) => {
    link.addEventListener('click', (e) => {
      if (document.body.classList.contains('cms-edit-mode')) {
        e.preventDefault();
        return;
      }
      closeMenu();
    });
  });
}
